<template>
  <div v-if="isVisible" class="mobile-suggester-wrapper">
    <div class="mobile-suggester">
      <div class="mobile-part">
        <div class="mobile-title">
          <div class="icon">
            <img src="static/login_logo.png" class="logo">
          </div>
          <p class="mobile-text">{{$t('app.onMobile')}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileSuggester',
  components: {
  },
  props: {},
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
  },
  mounted() {},
  methods: {
    handleResize() {
      this.isVisible = window.innerWidth < 975
      // this.$eventBus.showSuggester(this.isVisible);
    },
  },
};
</script>

<style lang="scss" scoped>
// used zeplin page:
// https://app.zeplin.io/project/5b43690ae94d40975e730dec/screen/5b4370a4324ca5795d828893
$windowWidth: 643px;
$windowHeight: 631px;
$usedWindowRate: 100vw / $windowWidth;

.mobile-suggester-wrapper {
  z-index: 5;
  position: absolute;
  text-align: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  .mobile-suggester {
    height: 100%;
    overflow: hidden;
    .mobile-part {
      margin-bottom: 10px !important;
      margin: 0 auto;
      width: 482px * $usedWindowRate;
      height: 100%;
      background: url("/static/img/sitebuild/large_splash.png") no-repeat center;
      background-clip: content-box;
      background-size: contain;
      margin-top: 0;
      background-position: left 0 bottom -3px;
      display: flex;
      justify-content: center;
      align-items: center;
      .mobile-title {
        .icon {
          .logo {
            width: 222px;
            max-height: 205px;
          }
        }

        .mobile-text {
          font-family: Roboto;
          font-weight: 500;
          color: #000000 !important;
          font-size: 30px;
          line-height: 40px;

          @media (max-width: 700px) {
            font-size: 18px;
            line-height: 26px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/layouts/MobileSuggester.vue